import React from "react"
import { slide as Menu } from "react-burger-menu"
import { NavbarToggler } from "reactstrap"
import { useSelector } from "swiipe.portal.shared"
import { layoutReducerActions, layoutSelectors } from "../../store/reducers/layoutReducer"
import useReduxDispatch from "../../store/useReduxDispatch"
import { useShowLoggedInMenus } from "./../../services/authService"

interface ISidebarProps {
    children?: React.ReactNode
}

const Sidebar = ({ children }: ISidebarProps) => {
    const isOpen = useSelector(layoutSelectors.navBarOpen)
    const dispatch = useReduxDispatch()
    const showLoggedInMenus = useShowLoggedInMenus()

    return (
        <>
            {showLoggedInMenus && <nav id="sidebar">{children}</nav>}
            <Menu
                burgerButtonClassName="d-none"
                isOpen={isOpen}
                onStateChange={(state) => dispatch(layoutReducerActions.setNavBarOpen(state.isOpen))}
            >
                <nav id="sidebar-mobile">
                    <NavbarToggler
                        onClick={() => dispatch(layoutReducerActions.setNavBarOpen(false))}
                        target="sidebar-collapse"
                        id="close-sidebar"
                    ></NavbarToggler>
                    {children}
                </nav>
            </Menu>
        </>
    )
}

export default Sidebar
